// utils/plotlyStyle.js
import theme from "../theme";
export const formatLabel = (label, maxLength = 10, maxLines = 2) => {
  if (!label) return '';

  const str = String(label);
  const chunks = str.match(new RegExp(`.{1,${maxLength}}`, 'g')) || [];

  if (chunks.length <= maxLines) {
    return chunks.join('<br>');
  }

  const limited = chunks.slice(0, maxLines);
  const last = limited[maxLines - 1];

  // 最終行だけ「…」つける
  limited[maxLines - 1] = last.slice(0, maxLength - 1) + '…';

  return limited.join('<br>');
};
export const plotlyStyle = {
  // カラーパレット
  colors: {
    line: '#1F75FF',  // 線グラフの色
    bar: '#1F75FF',   // 棒グラフの色
    background: '#fff', // 背景色
    text: '#333',      // テキストの色
    pie: ['#1F75FF', '#E74C3C', '#2ECC71', '#F39C12', '#9B59B6'],  // 円グラフの色（カスタマイズ可能）
  },

  // 共通レイアウト設定
  layout: {
    autosize: true,
    margin: { t: 60, b: 60, l: 80, r: 40 }, // 余白調整
    xaxis: {},
    yaxis: {

    },
    title: {
      font: {
        size: 13,
        family: 'Arial, sans-serif',
        color: theme.palette.text.main,
      },
      x: 0.5,   // タイトルを中央に配置
      xanchor: 'center',  // タイトル位置調整
    },

    // X軸の設定
    xaxis: {
      title: {
        font: { size: 10, color: theme.palette.text.main, },
      },
      automargin: true,
      tickangle: -90,  // X軸のラベルの角度
    },

    // Y軸の設定
    yaxis: {
      title: {
        font: { size: 10, color: theme.palette.text.main, },
      },
      automargin: true
    },
    legend: {
      x: 1, // 右端
      y: 1, // 上端
      xanchor: 'right',
      yanchor: 'top',
      orientation: 'v', // 縦方向に並べる
    },
    // 背景色設定
    plot_bgcolor: '#fff',  // グラフの背景色
    paper_bgcolor: '#fff', // グラフ全体の背景色

    // グリッド線などをカスタマイズしたい場合
    showgrid: true,
    gridcolor: '#ccc',
    zeroline: true,
    zerolinecolor: '#ccc',
  },

  // チャートデータのカラーパレット
  data: {
    line: {
      color: theme.palette.primary.main, // 線グラフの色
    },
    bar: {
      color: theme.palette.primary.main,  // 棒グラフの色
    },
    pie: {
      colors: [theme.palette.primary.main, '#E74C3C', '#2ECC71', '#F39C12', '#9B59B6'],  // 円グラフの色
    },
  },
};
